module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAABFElEQVRIS+2VPU7DMBiGn89RQ1nYuAIDA0gEwVQEF2DjAAxN2mN0R0xd2i5sHICRIV1BBMSA1HIFLtAfYiMjhRbV6dCIgSqWvFh+H1uv3++z8IdDftid8QWoXSS9Jay+f6/3xnsY2UfLNoYH1Osj0eF06X06kwMi/9numcG7kxjDKcgd+vMa5V0BgQNkhU9AgiKh7if0pjU0NYw+QckGoX/mhgt90rSF8uKVHLP6Er5gXWmLM01rb0sbiBH1guYDSY9B7DwCs5VbYMINoX+5vEKbm/1cQHe0g0iAlgAhwDAEPcB4bzQq95lusbfMPchK5T8nKuE5kc+Ws37+fz23P1FUOS+alN85d/2hBU+YRbEgyCX/AvKtvRiuB5IPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/maptool/draw/blq.png
// module id = 2vEU
// module chunks = 35